import { Action, createReducer, on } from '@ngrx/store';
import { ViewCacheActions } from '../actions';
import { initialState, ViewCacheState } from '../states/view-cache.states';

export const branchSettingsViewCacheFeatureKey = 'branchSettingsViewCache';

export const viewCacheReducer = createReducer(
  initialState,
  on(ViewCacheActions.cacheBranchSettings, (state, action) => ({...state, branchSettings: action.cache}))
);

export function reducer(state: ViewCacheState | undefined, action: Action) {
  return viewCacheReducer(state, action);
}


